import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _pickBy from "lodash/pickBy";
import { RESET_PLAID_ONBOARDING, getPortalForInstitution } from "../actions/financial-data";
import { deleteProviderAccount, loginToProvider, resetYodleeOnboarding, startYodleeOnboarding } from "../actions/yodlee";
var initialState = {
  portalsByInstitutionId: {},
  selectedPortalId: null
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case loginToProvider.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedPortalId: payload.id
        });
      }

    case getPortalForInstitution.SUCCESS_TYPE:
      {
        var _payload$data;

        var portal = payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.financialPortalByInstitutionId;
        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _objectSpread(_objectSpread({}, state.portalsByInstitutionId), {}, _defineProperty({}, portal.marketplaceInstitution.id, portal)),
          selectedPortalId: portal === null || portal === void 0 ? void 0 : portal.id
        });
      }

    case RESET_PLAID_ONBOARDING:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPortalId: null
      });

    case deleteProviderAccount.SUCCESS_TYPE:
      {
        // If a user unlinks a portal, clear the portal cache
        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _pickBy(state.portalsByInstitutionId, function (portal) {
            return portal.id !== payload.deletedPortalId;
          })
        });
      }

    case resetYodleeOnboarding.getType():
    case startYodleeOnboarding.getType():
      {
        if (payload !== null && payload !== void 0 && payload.portalId) {
          return _objectSpread(_objectSpread({}, state), {}, {
            selectedPortalId: payload.portalId
          });
        }

        return state;
      }

    default:
      return state;
  }
});